import { styled } from 'styled-components';
import { SectionBase } from '@ydistri/ds';
import { ValidatorProps } from './Validator';
import { computeRemSize } from '@ydistri/theme';

/**
 * - size "small" (28px) is used in "Create calculation" modal
 * - size "large" (28px) is used in configuration header
 */
export const ValidatorButton = styled(SectionBase)<{ $size: ValidatorProps['size'] }>`
  width: 125px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1rem;
  gap: 0.5rem;
  height: ${p => computeRemSize(p.$size === 'small' ? 26 : 32)};
  padding: ${computeRemSize(6)} 1rem;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  cursor: pointer;
`;
